import axios from 'axios';

export default {
  fetchAvContract({
    commit,
  }, id) {
    return axios.get(`/avContract/show/${id}`)
      .then((res) => {
        const hiddenFields = {
          fields: res.meta.invisibleFields,
          domain: 'avContract',
        };

        commit('app/setHiddenFields', hiddenFields, {
          root: true,
        });

        return res;
      });
  },
  saveAvContract(_, avContract) {
    return axios.post('/avContract', avContract);
  },
  copyAvContract(_, avContract) {
    return axios.post('/avContract/copy', avContract);
  },
};
